import type { IUserData } from "@/features/auth/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthStore {
  isAuth: boolean;
  setIsAuth: (value: boolean) => void;
  user: IUserData | null;
  setUser: (user: IUserData | null) => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      isAuth: false,
      setIsAuth: (value) => set({ isAuth: value }),
      user: null,
      setUser: (user) => set({ user }),
    }),
    { name: "auth-store" },
  ),
);
